module.exports = __webpack_public_path__ + "img/2.f45905f7.jpg";